import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {updateEvent} from '../helpers'
import {EventUpdate, ShiftEvent} from '../types'

interface EventUpdateParams {
  plantId: string
  timezone: string
}

type Variables = {
  event: EventUpdate
  scheduleRecurringTask?: boolean
}

export const useEventUpdate = (
  {timezone, plantId}: EventUpdateParams,
  options?: UseMutationOptions<ShiftEvent, AxiosError, Variables>
) => {
  const queryClient = useQueryClient()

  return useMutation<ShiftEvent, AxiosError, Variables, unknown>({
    mutationFn: (variables) =>
      updateEvent(
        ApiClient.axiosInstance,
        plantId,
        variables.event,
        timezone,
        variables.scheduleRecurringTask
      ),
    // allow the caller to override the default options
    ...options,

    // make sure to invalidate the Queries after the regular onSuccess process is done
    onSuccess: (data, variables, context, mutation) => {
      // promise results are not required, hence we can just trigger the promises
      // This is a quick-fix for HCP-23572
      void options?.onSuccess?.(data, variables, context, mutation)
      void queryClient.invalidateQueries()
    }
  })
}
